<!-- FirstComponent.vue -->
<template>
    <h4>{{ title }}</h4>

    <div v-if="isLoading" class="event-loading-spinner"><i class="fa fa-spinner fa-spin fa-3x"></i></div>
    <div id="post-list" v-else>
        <div class="posts-list">
            <ul>
                <li v-for="(page, index) in this.blogPages" :key="index"><a :href="page.Url">{{ page.Name }}</a></li>
            </ul>
        </div>

        <button v-if="!isButtonHide" class="btn btn-primary" type="submit" @click="onClick">{{ buttonName }}</button>
    </div>
</template>

<script>
export default {
    name: 'FirstComponent',
    props: {
        culture: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            blogPages: [],
            buttonName: '',
            title: '',
            isButtonHide: false,
            isLoading: true,
        }
    },
    computed: {

    },
    methods: {
        async onClick() {
            await this.fetchAllPosts();
            this.isButtonHide = true;
            this.scrollToElement();
        },
        scrollToElement() {
            const element = document.getElementById("post-list");
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        },
        async fetchPosts() {
            this.isLoading = true;
            const url = `/blog/latest/take?culture=${this.culture}&amount=20`;
            try {
                const response = await fetch(url);

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                let result = await response.json();

                this.blogPages = result.Posts;
                this.buttonName = result.ShowMoreLabel;
                this.title = result.LatestTitle;

            } catch (err) {
                console.error('Fetch error:', err);
            } finally {
                this.isLoading = false;
            }
        },
        async fetchAllPosts() {
            this.isLoading = true;

            const url = `/blog/latest?culture=${this.culture}`;
            try {
                const response = await fetch(url);

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                let result = await response.json();

                this.blogPages = result;
            } catch (err) {
                console.error('Fetch error:', err);
            } finally {
                this.isLoading = false;
            }
        },
    },
    mounted() {
        this.fetchPosts();
    }
};
</script>
